// extracted by mini-css-extract-plugin
export default {"enrolmentImageBox":"EnrolmentImage_enrolmentImageBox__E0LAy","h1Title":"EnrolmentImage_h1Title__ZkqQR","h1TitleSpan":"EnrolmentImage_h1TitleSpan__UDg3V"};